import { render, staticRenderFns } from "./dialogTransferCandidate.vue?vue&type=template&id=397cca04&scoped=true"
import script from "./dialogTransferCandidate.vue?vue&type=script&lang=js"
export * from "./dialogTransferCandidate.vue?vue&type=script&lang=js"
import style0 from "./dialogTransferCandidate.vue?vue&type=style&index=0&id=397cca04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397cca04",
  null
  
)

export default component.exports